// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3apMX","content":"styles_content__2OF9m","checkbox":"styles_checkbox__2S4s0","checkboxLabel":"styles_checkboxLabel__1k9Ef"};